export enum SortTypes {
  ID = 'Id',
  FROM = 'From',
}
